import { useEffect, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
export const ONBOARDING_AGENT_GTM_EXPERIMENT_EVENT = "onboarding_agent_ab_test";

// Access (the OnboardingAgent claim) is enforced by the GrowthBook experiment targeting attribute
// `hasAccessToOnboardingBot`, so the experiment alone implies the user is eligible.
export const isOnboardingAgentExperimentEnabled = (): boolean =>
    GrowthbookService.growthbookInstance.isOn(TestsNames.ONBOARDING_AGENT);

export const isNotSI = (): boolean => !proNavigator.isSalesSolution();

export const isOnboardingAgentEnabled = (): boolean => isOnboardingAgentExperimentEnabled() && isNotSI();

export const isQualifiedChatEnabled = (): boolean => !isOnboardingAgentExperimentEnabled();

export const useOnboardingAgentEnabled = (): boolean => {
    const [isEnabled, setIsEnabled] = useState(isOnboardingAgentEnabled);
    const { state: routerState } = useCurrentStateAndParams();

    useEffect(() => {
        setIsEnabled(isOnboardingAgentEnabled());
    }, [routerState.name]);

    useEffect(
        () =>
            GrowthbookService.growthbookInstance.subscribe(() => {
                queueMicrotask(() => {
                    setIsEnabled(isOnboardingAgentEnabled());
                });
            }),
        [],
    );

    return isEnabled;
};

export const syncOnboardingAgentExperimentWithGtm = (): void => {
    const isExperimentVariation = isOnboardingAgentExperimentEnabled();
    const showOnboardingBot = isOnboardingAgentEnabled();
    const showQualifiedChat = isQualifiedChatEnabled();

    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
        event: ONBOARDING_AGENT_GTM_EXPERIMENT_EVENT,
        onboarding_agent_ab_test_name: TestsNames.ONBOARDING_AGENT,
        onboarding_agent_ab_test_variant: isExperimentVariation ? "variation" : "control",
        onboarding_agent_show_qualified_chat: showQualifiedChat,
        onboarding_agent_show_onboarding_bot: showOnboardingBot,
    });
};
